import { atom } from "jotai";

export type AddressBookPane = "list" | "detail";

/**
 * Panel to show when the modal is too narrow to display the contact list and
 * the contact detail side by side. Above that breakpoint both panels are
 * always visible and this value is ignored by the layout.
 */
export const paneAtom = atom<AddressBookPane>("list");

export const showListPaneAtom = atom(null, (_get, set) => {
  set(paneAtom, "list");
});
